'use es6';

import { SLINKY } from 'HubStyleTokens/colors';
import { ERROR, WARNING, INFO, SUCCESS } from 'DesignData/enums/EditorErrorTypes';
export const NAME_LABEL_ICON_SIZE = 40;
export const DEFAULT_WIDGET_ICON = 'customModules';
export const DEFAULT_LAYOUT_ICON = 'dragAndDropLayout';
export const DEFAULT_TEMPLATE_ICON = 'htmlFile';
export const DEFAULT_CSS_ICON = 'cssFile';
export const DEFAULT_JS_ICON = 'jsFile';
export const DEFAULT_JSON_ICON = 'jsonFile';
export const DEFAULT_FONT_ICON = 'fontFile';
export const DEFAULT_IMAGE_ICON = 'insertImage';
export const DEFAULT_GLOBAL_WIDGET_ICON = 'globalGroup';
export const DEFAULT_GLOBAL_GROUP_ICON = 'partial';
export const DEFAULT_CODED_FILE_ICON = 'code';
export const DEFAULT_PARTIAL_ICON = 'partial';
export const DEFAULT_FILE_ICON = 'file';
export const DEFAULT_MARKDOWN_FILE_ICON = 'markdownFile';
export const DEFAULT_GRAPHQL_FILE_ICON = 'graphqlFile';
export const DEFAULT_FOLDER_ICON = 'folder';
export const DEFAULT_OPEN_FOLDER_ICON = 'folderOpen';
export const THEME_FOLDER_ICON = 'folderTheme';
export const OPEN_THEME_FOLDER_ICON = 'folderThemeOpen';
export const DEFAULT_SERVERLESS_FUNCTION_FOLDER_ICON = 'folderServerlessFunction';
export const DEFAULT_SERVERLESS_FUNCTION_OPEN_FOLDER_ICON = 'folderServerlessFunctionOpen'; // TODO - Update the project icons when they are added to spacesword https://private.hubteam.com/opengrok/xref/all/git.hubteam.com-HubSpot-react-native-fonts%23master/spacesword-android-compatible-mapping.json

export const DEFAULT_PROJECT_FOLDER_ICON = 'folder';
export const DEFAULT_PROJECT_OPEN_FOLDER_ICON = 'folderOpen';
export const SMART_CONTENT_ICON = 'replace';
export const ORPHAN_WIDGET_ICON = 'unlink';
export const SAVE_INFO_ICON = 'info';
export const SAVE_ERROR_ICON = 'reportSpam';
export const SAVE_SUCCEED_ICON = 'success';
export const SAVE_WARNING_ICON = 'warning';
export const LAYOUT_WIDGET_ICON_COLOR = SLINKY;
export const FINDER_FILE_ICON_MAP = Object.freeze({
  LAYOUT: DEFAULT_LAYOUT_ICON,
  TEMPLATE: DEFAULT_TEMPLATE_ICON,
  CSS: DEFAULT_CSS_ICON,
  JS: DEFAULT_JS_ICON,
  CUSTOM_WIDGET: DEFAULT_WIDGET_ICON,
  GLOBAL_WIDGET: DEFAULT_GLOBAL_WIDGET_ICON,
  GLOBAL_GROUP: DEFAULT_PARTIAL_ICON,
  MD: DEFAULT_MARKDOWN_FILE_ICON,
  GRAPHQL: DEFAULT_GRAPHQL_FILE_ICON
});
export const RAW_ASSET_ICON_MAP = Object.freeze({
  DEFAULT: DEFAULT_FILE_ICON,
  IMAGE: DEFAULT_IMAGE_ICON,
  FONT: DEFAULT_FONT_ICON,
  JSON: DEFAULT_JSON_ICON,
  JS: DEFAULT_JS_ICON,
  MD: DEFAULT_MARKDOWN_FILE_ICON,
  GRAPHQL: DEFAULT_GRAPHQL_FILE_ICON
});
export const EDITOR_ERROR_ICON_MAP = Object.freeze({
  [ERROR]: SAVE_WARNING_ICON,
  [WARNING]: SAVE_WARNING_ICON,
  [INFO]: SAVE_INFO_ICON,
  [SUCCESS]: SAVE_SUCCEED_ICON
});